module.exports = __webpack_public_path__ + "img/pdbLog.31940fbe.png";